  <div class="mt-4">
    <app-loading-spinner *ngIf="!classesDataLoaded"></app-loading-spinner>
    <ng-container *ngIf="classesDataLoaded">
      <table class="table" *ngIf="hasClasses">
        <thead>
          <th>
            <app-sort-toggle columnName="Description" (orderChange)="updateSort($event)">
              Class Name
            </app-sort-toggle>
            
          </th>
          <th>
            <app-sort-toggle columnName="TeacherName" (orderChange)="updateSort($event)">
              Teacher
            </app-sort-toggle>
          </th>
          <th>
            <app-sort-toggle columnName="StudentCount" (orderChange)="updateSort($event)">
              Total Students
            </app-sort-toggle>
            
          </th>
          <th>
            <app-sort-toggle columnName="ActiveStudentCount" (orderChange)="updateSort($event)">
              Active Students
            </app-sort-toggle>
           
          </th>
          <th>
            <app-sort-toggle columnName="AverageMinutesInProduct" (orderChange)="updateSort($event)">
              Average Time per Student
            </app-sort-toggle> 
          </th>
          <th>
            <app-sort-toggle columnName="AverageUnitTestPctCorrect" (orderChange)="updateSort($event)">
              Unit Test Average
            </app-sort-toggle> 
          </th>
          <th>
            <app-sort-toggle columnName="TotalNumSpeakingOpportunities" (orderChange)="updateSort($event)">
              Speaking Opportunities
            </app-sort-toggle>   
          </th>
          <th>
            <app-sort-toggle columnName="AverageSparcScore" (orderChange)="updateSort($event)">
              SPARC Score
            </app-sort-toggle>   
          </th>
        </thead>
        <tbody>
          <tr *ngFor="let theClass of classes; index as i" class="hover"
            (click)="goToRoute(theClass, '/classes/' + theClass.ClassSectionID + '/class/' + theClass.ID)">
            <td>
              <div class="d-flex">
                {{ theClass.Description }}
              </div>
            </td>
            <td>
              <div class="d-flex">
                {{ theClass.TeacherName }}
              </div>
            </td>
            <td>
              <div class="d-flex">
                {{ theClass.StudentCount }}
              </div>
            </td>
            <td>
              <div class="d-flex">
                {{ theClass.ActiveStudentCount }} ({{ getActiveStudentsString(theClass.StudentCount,theClass.ActiveStudentCount) }})
              </div>
            </td>
            <td>
              <div class="d-flex">
                {{ getFormattedTimeString(theClass.AverageMinutesInProduct) }} 
              </div>
            </td>
            <td>
              <div class="d-flex">
                {{ getUnitTestAverage(theClass.AverageUnitTestPctCorrect) }}
              </div>
            </td>
            <td>
              <div class="d-flex">
                {{ theClass.TotalNumSpeakingOpportunities }}
              </div>
            </td>
            <td>
              <div class="d-flex">
                {{ theClass.AverageSparcScore }}
                <div *ngIf="theClass.AverageSparcScore > theClass.LastMonthAverageSparcScore" class="speaking-score-icon"
                ngbTooltip="Class average has gone up since last month." placement="end"
                tooltipClass="custom-tooltip-styling"><i class="fas fa-caret-up h4" style="color: #79C045;"></i></div>
                <div *ngIf="theClass.AverageSparcScore < theClass.LastMonthAverageSparcScore" class="speaking-score-icon"
                ngbTooltip="Class average has gone down since last month." placement="end"
                tooltipClass="custom-tooltip-styling"><i class="fas fa-caret-down h4" style="color: #FD362C;"></i></div>
              </div>
            </td>
            
            
          </tr>
        </tbody>
      </table>
      <h3 *ngIf="!hasClasses">No class data to display.</h3>
    </ng-container>
  </div>
